/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const UploadFileSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 27.517 27.517"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12.143 8.303v9.314a2 2 0 104 0l-.122-9.193a4 4 0 10-7.999 0l.12 9.193a6 6 0 0012.001 0l.01-8.84"
      data-name="Path 1"
    ></path>
  </svg>
);

export const UploadFileIcon = (props) => (
  <Icon component={UploadFileSvg} {...props} />
);
